import React, { useMemo } from 'react';
import cs from 'classnames';
export const Checkbox = React.forwardRef(
    (
        {
            srLabel,
            id,
            name,
            labelBold,
            label,
            labelClassName = 'text-gray-500',
            checked,
            setChecked,
            height = 'h-5',
            variant = 'primary',
            checkboxClassName = '',
            bgColor,
            wrap = false,
            disabled = false,
        }: {
            srLabel: string;
            id: string;
            name: string;
            labelBold?: string;
            label: string;
            labelClassName?: string;
            checked: boolean;
            setChecked: React.ChangeEventHandler<HTMLInputElement>;
            height?: string;
            checkboxClassName?: string;
            variant?: 'primary' | 'secondary' | 'answerNotSelected' | 'wrong';
            bgColor?: string;
            wrap?: boolean;
            disabled?: boolean;
        },
        ref: React.ForwardedRef<HTMLInputElement>,
    ) => {
        const inputClass = cs(
            'form-checkbox cursor-pointer appearance-none focus:outline-none border-gray-300 rounded',
            {
                ['checked:bg-teal-600 checked:border-transparent focus:ring-primary text-primary']:
                    variant === 'primary' && !bgColor,
                ['checked:bg-magenta-600 checked:border-transparent focus:ring-secondary text-secondary']:
                    variant === 'secondary' && !bgColor,
                ['checked:bg-green-600 checked:border-transparent focus:ring-green-600 text-secondary']:
                    variant === 'answerNotSelected' && !bgColor,
                ['checked:bg-red-600 checked:border-transparent focus:ring-green-600 text-secondary']:
                    variant === 'wrong' && !bgColor,
                [`${height} w-5`]: !!height,
                [`${height} w-4`]: height === 'h-4',
                ['h-6 w-6']: !height,
            },
        );

        const checkedBgStyle = checked && !!bgColor ? { backgroundColor: bgColor } : {};

        return (
            <fieldset className="flex items-center">
                <legend className="sr-only">{srLabel}</legend>
                <div className={`inline-flex items-top justify-center ${checkboxClassName}`}>
                    <div className={`flex items-center ${height} `}>
                        <input
                            id={id}
                            ref={ref}
                            aria-describedby={`${id}-description"`}
                            name={name}
                            value={checked ? '1' : '0'}
                            type="checkbox"
                            onChange={setChecked}
                            checked={checked}
                            disabled={disabled}
                            className={inputClass}
                            style={checkedBgStyle}
                        />
                    </div>
                    <div
                        className={`ml-3 text-md ${
                            wrap ? 'whitespace-wrap' : 'whitespace-nowrap'
                        }`}>
                        <label htmlFor={id} className="cursor-pointer">
                            {labelBold}
                            <span id={`${id}-description"`} className={labelClassName}>
                                <span className="sr-only">{labelBold}</span> {label}
                            </span>
                        </label>
                    </div>
                </div>
            </fieldset>
        );
    },
);

Checkbox.displayName = 'CheckboxesComponent';
